/**
 * Client-side session helpers.
 *
 * Auth uses an HttpOnly cookie (set by the backend on login/onboard/reset) that
 * JavaScript CANNOT read — that's the point: a stolen-via-XSS token is not a
 * risk because there's nothing for a script to steal. The cookie is sent
 * automatically on same-origin requests (api.js uses credentials: 'include').
 *
 * What we keep in localStorage is only a NON-SECRET cache of the client summary
 * (id + org name) so the UI can render immediately without waiting on /api/me.
 * It is not an auth credential — the cookie is the only thing that authorizes a
 * request. If the cookie is missing/expired, the API returns 401 and the app
 * clears this cache and redirects to sign-in.
 */

const CLIENT_ID_KEY = 'gs_client_id'
const ORG_NAME_KEY = 'gs_org_name'

// Store the non-secret client summary returned alongside the auth cookie.
export function setSession({ client } = {}) {
  if (client?.client_id) localStorage.setItem(CLIENT_ID_KEY, client.client_id)
  if (client?.org_name) localStorage.setItem(ORG_NAME_KEY, client.org_name)
}

export function getClientId() {
  return localStorage.getItem(CLIENT_ID_KEY)
}

export function getOrgName() {
  return localStorage.getItem(ORG_NAME_KEY)
}

// Optimistic gate for first render. The cookie is the real authority; an invalid
// cookie surfaces as a 401 on the first API call, which clears this and bounces
// the user to /signin.
export function hasCachedSession() {
  return !!localStorage.getItem(CLIENT_ID_KEY)
}

export function clearSession() {
  localStorage.removeItem(CLIENT_ID_KEY)
  localStorage.removeItem(ORG_NAME_KEY)
}
